import React from 'react';
import { NavLink, useLocation } from 'react-router-dom';
import './DigestsPage.css';

/* Campaigns and release digests are both "email", but only one of them is
 * something you write — so they are two screens rather than one list with a
 * type column. This strip is how you get between them. */
const EmailsTabs = () => {
    const { pathname } = useLocation();
    const onDigests = pathname.startsWith('/admin/emails/digests');
    return (
        <nav className="emails-tabs" aria-label="Email sections">
            <NavLink to="/admin/emails" className={`emails-tab ${onDigests ? '' : 'on'}`}>Campaigns</NavLink>
            <NavLink to="/admin/emails/digests" className={`emails-tab ${onDigests ? 'on' : ''}`}>Release digests</NavLink>
        </nav>
    );
};

export default EmailsTabs;
